import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../app-config.service';
import { inject } from '@angular/core';
import { OrderId } from '@web/dtos';
import { Observable } from 'rxjs';
import { IApiResponse } from '@web/shared-types';
import { map } from 'rxjs/operators';

export class ReportDesignerGateway {
  private readonly restCallBuilder: RestCallBuilder<any> =
    new RestCallBuilder<any>({});

  private readonly configService: AppConfigService = inject(AppConfigService);

  getProofOfPurchase(orderId: OrderId): Observable<string> {
    return this.restCallBuilder
      .getExternal(
        `${this.configService.get().general.directTicketUrl}/orders/proof-of-purchase/${orderId}`
      )
      .handleMessages()
      .build()
      .pipe(map((response: IApiResponse<string>) => response.data ?? ''));
  }
}
